import s from "./Heading.module.scss";
import st from "@/styles/modules/typography.module.scss";
import cn from "classnames";
import { CSSProperties } from "react";

type HeadingProps = {
  id?: string;
  tag?: number;
  level: number;
  children?: React.ReactNode;
  className?: string;
  html?: string;
  style?: CSSProperties;
};

export const Heading = ({ id, tag, level = 2, children, className, html, style }: HeadingProps) => {
  const Tag = tag === 0 ? "div" : (`h${tag ? tag : level}` as "h1" | "h2" | "h3" | "h4" | "h5" | "h6");

  const classValue = cn(s.heading, st[`headingH${level}`], className);

  return html ? (
    <Tag style={style} id={id} className={classValue} dangerouslySetInnerHTML={{ __html: html }} />
  ) : (
    <Tag id={id} className={classValue} style={style}>
      {children}
    </Tag>
  );
};
